<template>
    <div>
        <div class="az-form-content">
            <painel-documento-solicitado-edicao v-model="compraDireta.documentosSolicitados" :documentos="documentos"
                                                @adicionarNovoDocumento="tratarEventoAdicionarDocumento"
                                                @adicionarDocumentoSemVinculo="tratarEventoAdicionarDocumentoSemVinculo"
                                                @excluirDocumento="tratarEventoExcluirDocumentoSolicitado"/>

            <painel-linha-fornecimento-edicao v-model="compraDireta.linhasFornecimento"
                                              @adicionarLinhaFornecimento="tratarEventoAdicionarLinha"
                                              @excluirLinhaFornecimento="tratarEventoExclusaoLinha"/>

            <painel-convidado-edicao v-model="compraDireta.convidados"
                                     @adicionarEmailConvidado="tratarEventoAdicionarConvidado"
                                     @excluirEmailConvidado="tratarEventoExclusaoConvidado"/>
        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <div class="align-right">
                <az-call-to-action id="botaoPublicar" @click="exibirMensagemConfirmacaoPublicacao"
                                   :disabled="requisicaoPublicacaoEmAndamento"
                                   :css-class="`action-primary botao-publicar text-uppercase d-flex align-center ${requisicaoPublicacaoEmAndamento?'desabilitado':''}`">
                    Publicar
                    <v-icon color="white">
                        keyboard_arrow_right
                    </v-icon>
                </az-call-to-action>
            </div>
        </div>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoConfirmacaoPublicacao"
                              titulo="Publicar Compra Direta"
                              textoPrimario="Essa ação disponibiliza a compra para recebimento de propostas."
                              textoSecundario="Deseja realmente publicar?"
                              botaoRecusar="Cancelar"
                              botaoConfirmar="Publicar"
                              tamanhoMaximo="350"
                              @confirmado="tratarEventoPublicar"
                              @recusado="fecharMensagemConfirmacaoPublicacao"/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import PainelDocumentoSolicitadoEdicao
from '@/views/pages/comprador/execucao-compra-direta/documentos/painel-documento-solicitado/PainelDocumentoSolicitadoEdicao'
import PainelLinhaFornecimentoEdicao
from '@/views/pages/comprador/execucao-compra-direta/documentos/painel-linha-fornecimento/PainelLinhaFornecimentoEdicao'
import PainelConvidadoEdicao
from '@/views/pages/comprador/execucao-compra-direta/documentos/painel-convidado/PainelConvidadoEdicao'

export default {
    name: 'DocumentosEdicao',
    components: {
        PainelDocumentoSolicitadoEdicao,
        PainelLinhaFornecimentoEdicao,
        PainelConvidadoEdicao
    },
    data() {
        return {
            compraDiretaId: null,
            documentos: [],
            rotasAvancar: [
                {
                    name: 'AcompanhamentoVisualizacao'
                }
            ],
            mostrarDialogoConfirmacaoPublicacao: false,
            requisicaoPublicacaoEmAndamento: false
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDocumentosDaProposta()
            await this.buscarDocumentosSolicitados()
            await this.buscarLinhasFornecimentoDaCompraDireta()
            await this.buscarConvidadosDaCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    computed: {
        ...mapState(['compraDireta', 'resumoCompraDireta'])
    },
    beforeRouteLeave(to, from, next) {
        if (this.verificarRotaAvancar(to.name) && this.resumoCompraDireta.situacao === 'EM_ELABORACAO') {
            this.mostrarNotificacaoErro('Publique sua compra direta para continuar.')
        } else {
            next()
        }
    },
    methods: {
        async buscarDocumentosDaProposta() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA)
            this.documentos = this.$store.state.documentosProposta
        },
        async buscarDocumentosSolicitados() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_SOLICITADOS, this.compraDiretaId)
        },
        async buscarLinhasFornecimentoDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        async buscarConvidadosDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_CONVIDADOS_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        async tratarEventoAdicionarDocumento(documentoId) {
            const objDocumento = {
                compraDiretaId: this.compraDiretaId,
                documentoId
            }
            await this.$store.dispatch(actionTypes.ADICIONAR_DOCUMENTO_SOLICITADO, objDocumento)
        },
        async tratarEventoAdicionarDocumentoSemVinculo(nomeDocumento) {
            const objDocumento = {
                documento: {
                    nome: nomeDocumento,
                    obrigatorio: false,
                    editavel: false
                },
                compraDiretaId: this.compraDiretaId
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.ADICIONAR_DOCUMENTO_SEM_VINCULO, objDocumento)
            await this.buscarDocumentosDaProposta()
        },
        async tratarEventoAdicionarLinha(linha) {
            const objLinha = {
                compraDiretaId: this.compraDiretaId,
                linha
            }
            await this.$store.dispatch(actionTypes.ADICIONAR_LINHA_DE_FORNECIMENTO, objLinha)
        },
        async tratarEventoAdicionarConvidado(email) {
            const objEmail = {
                compraDiretaId: this.compraDiretaId,
                email
            }
            await this.$store.dispatch(actionTypes.ADICIONAR_EMAIL_CONVIDADO, objEmail)
        },
        async tratarEventoExcluirDocumentoSolicitado(documentoSolicitadoId) {
            const docASerRemovido = {
                compraDiretaId: this.compraDiretaId,
                documentoSolicitadoId
            }
            await this.$store.dispatch(actionTypes.REMOVER_DOCUMENTO_SOLICTADO, docASerRemovido)
            this.mostrarNotificacaoSucesso('Documento excluído com sucesso.')
        },
        async tratarEventoExclusaoLinha(linhaId) {
            const linhaASerRemovida = {
                compraDiretaId: this.compraDiretaId,
                linhaFornecimentoCompraDiretaId: linhaId
            }
            await this.$store.dispatch(actionTypes.REMOVER_LINHA_FORNECIMENTO, linhaASerRemovida)
            this.mostrarNotificacaoSucesso('Linha de fornecimento excluída com sucesso.')
        },
        async tratarEventoExclusaoConvidado(convidadoId) {
            const emailASerRemovida = {
                compraDiretaId: this.compraDiretaId,
                convidadoId
            }
            await this.$store.dispatch(actionTypes.REMOVER_EMAIL_CONVIDADO, emailASerRemovida)
            this.mostrarNotificacaoSucesso('E-mail excluído com sucesso.')
        },
        async tratarEventoPublicar() {
            this.mostrarDialogoConfirmacaoPublicacao = false
            this.requisicaoPublicacaoEmAndamento = true
            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Publicando a compra direta...')
            try {
                await this.$store.dispatch(actionTypes.PUBLICAR_COMPRA_DIRETA, this.compraDiretaId)
                this.mostrarNotificacaoSucesso('Compra direta publicada com sucesso.')
            } catch (e) {
                this.desabilitarLoadingGlobal()
                this.requisicaoPublicacaoEmAndamento = false
                if (e.name !== 'ApiErrorValidations' || !('errorMessages' in e.response.data)){
                    throw e
                }
                throw new Error(e.response.data.errorMessages[0].message)
            }
            this.desabilitarLoadingGlobal()
            await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)

            if (this.resumoCompraDireta.situacao === 'EM_ELABORACAO') {
                await new Promise(resolve => setTimeout(resolve, 3000))
                await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, this.compraDiretaId)
            }
            this.redirecionarParaProximaPagina()
        },
        exibirMensagemConfirmacaoPublicacao() {
            this.mostrarDialogoConfirmacaoPublicacao = true
        },
        fecharMensagemConfirmacaoPublicacao() {
            this.mostrarDialogoConfirmacaoPublicacao = false
        },
        tratarEventoVoltar() {
            this.redirecionarParaPaginaAnterior()
        },
        redirecionarParaProximaPagina() {
            this.$router.push({name: 'AcompanhamentoVisualizacao', params: this.compraDiretaId})
        },
        redirecionarParaPaginaAnterior() {
            this.$router.push({name: 'ItensLotesEdicao', params: this.compraDiretaId})
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        verificarRotaAvancar(rotaDestino) {
            return this.rotasAvancar.some(rota => {
                return rota.name === rotaDestino
            })
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-publicar
        background-color var(--v-primary-base) !important
        border 0 !important
        color #fff !important

    .desabilitado
        background-color #EBEBEB !important
        border 0 !important
        color #B8B8B8 !important
        pointer-events none

        i
            color #B8B8B8 !important
</style>
